export default __webpack_public_path__ + "static/media/eva_ajbrin.f6a82517.jpg";